var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 315,
    height: 91,
    viewBox: "0 0 315 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12837",
    "data-name": "Group 12837",
    transform: "translate(998 -8316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1505",
    "data-name": "Rectangle 1505",
    width: 315,
    height: 91,
    rx: 45.5,
    transform: "translate(-998 8316)",
    fill: "#fdeebe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12769",
    "data-name": "Group 12769",
    transform: "translate(-12 2107.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12790",
    "data-name": "Group 12790",
    transform: "translate(-911 6229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12652",
    "data-name": "Group 12652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3460",
    "data-name": "Path 3460",
    d: "M-447,201.027q0-7.464,0-14.928a5.656,5.656,0,0,1,6.04-6.04q14.994,0,29.988,0a5.653,5.653,0,0,1,6.041,6.039q0,14.994,0,29.988a5.659,5.659,0,0,1-6.04,6.041q-15.027,0-30.054,0A5.649,5.649,0,0,1-447,216.153Q-447,208.59-447,201.027Zm21.034-16.783q-7.267,0-14.534,0a2.111,2.111,0,0,0-2.314,2.329q0,14.5,0,29a2.132,2.132,0,0,0,2.346,2.366q14.5,0,29,0a2.126,2.126,0,0,0,2.349-2.365q0-14.468,0-28.936a2.137,2.137,0,0,0-2.382-2.4Q-418.733,184.242-425.967,184.244Z",
    transform: "translate(455.43 -171.638)",
    fill: "#3a850f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3461",
    "data-name": "Path 3461",
    d: "M-504.773,158.067a5.627,5.627,0,0,1-6.281-5.487c-.036-2.081-.008-4.164-.009-6.247q0-12.132,0-24.263a5.65,5.65,0,0,1,5.993-6.02q15.124,0,30.248,0a5.656,5.656,0,0,1,5.8,6.287h-30.205a5.265,5.265,0,0,0-5.544,5.516q0,14.7,0,29.393Z",
    transform: "translate(511.073 -116.047)",
    fill: "#3a850f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3462",
    "data-name": "Path 3462",
    d: "M-378.407,271.312a5.962,5.962,0,0,1,.508-.728q5.848-5.863,11.708-11.714a2.914,2.914,0,0,1,3.569-.792c1.267.66,2.482,1.967,2.158,3.564a3.661,3.661,0,0,1-.879,1.772q-7.459,7.55-15,15.023a2.914,2.914,0,0,1-4.331-.037q-2.209-2.2-4.375-4.451a2.949,2.949,0,0,1,0-4.244,3.119,3.119,0,0,1,3.3-1.238,3.932,3.932,0,0,1,1.446.84C-379.669,269.87-379.129,270.536-378.407,271.312Z",
    transform: "translate(402.406 -239.118)",
    fill: "#3a850f"
  })), /*#__PURE__*/React.createElement("text", {
    id: "select",
    transform: "translate(115.337 36.705)",
    fill: "#3a850f",
    fontSize: 32,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -48,
    y: 0
  }, "select")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/Select.2de7457a3e36069cb7ddea513888a9f6.svg";
export { ForwardRef as ReactComponent };